import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { SuspenseWrapper } from '@components';
import { LazyInvoiceList } from '@components/lazy';
import { InvoiceStatus } from '@types';

export const InvoicesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const statusFromUrl = searchParams.get('status') as InvoiceStatus | null;

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-secondary-800 mb-2">
          Invoice Management
        </h1>
        <p className="text-secondary-600">
          View, search, and manage all processed invoices
        </p>
      </div>

      <SuspenseWrapper>
        <LazyInvoiceList initialStatus={statusFromUrl} />
      </SuspenseWrapper>
    </div>
  );
}; 